import { render } from "./ProfileNoCreditModal.vue?vue&type=template&id=2d49d020&scoped=true"
import script from "./ProfileNoCreditModal.vue?vue&type=script&lang=js"
export * from "./ProfileNoCreditModal.vue?vue&type=script&lang=js"

import "./ProfileNoCreditModal.vue?vue&type=style&index=0&id=2d49d020&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d49d020"]])

export default __exports__